import get from 'lodash/get';

const NAMESPACE = 'profiles';

export const selectHasTopicFetchFailed = (state, topicGuideId) =>
  Boolean(get(state, [NAMESPACE, topicGuideId, 'hasFailed'], false));
export function selectGuideItem(state, id) {
  return get(state, [NAMESPACE, id]);
}
